import { Model } from '@/models/Model';
export class Room extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Room';
        this.$endpoint = '/rooms';
        this.$fillable = ['name', 'color', 'capacity', 'lesson_types', 'levels'];
    }
}
